exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#NotificationsTable {\n  color: #000;\n}\n#NotificationsTable a {\n  color: #000;\n}\n#NotificationsTable .notification-read {\n  color: #999;\n}\n#NotificationsTable .notification-read a {\n  color: #999;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/app/shared/layout/notifications/notifications.component.less
// module id = ../../../../../src/app/shared/layout/notifications/notifications.component.less
// module chunks = main